import { HttpClient } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { ProductsService } from 'src/app/_services/products.service';

@Component({
  selector: 'app-image-upload',
  templateUrl: './image-upload.component.html',
  styleUrls: ['./image-upload.component.scss']
})
export class ImageUploadComponent implements OnInit {
  // imageData = "assets/150-26.jpg";
  @Input() dummyImageData = "https://preview.keenthemes.com/metronic8/demo2/assets/media/svg/files/blank-image.svg";

  fileToUpload: any;

  @Input() imageData = "https://preview.keenthemes.com/metronic8/demo2/assets/media/svg/files/blank-image.svg"

  @Input() isLabelPrinting = false;

  constructor(
    public _productService: ProductsService
  ) {

  }

  ngOnInit(): void {
    let imageUrl = this.imageData; // Example input
    const defaultUrl = 'assets/images/no-image.png'; // Your desired default image path

    if (imageUrl.includes('commonfiles/DefaultProductImage.png')) {
    this.imageData = this.dummyImageData;
    }
  }

  handleFileInput(event: any) {
    try {
      let file = event.target.files;
      this.fileToUpload = file.item(0);
      const self = this
      //Show image preview
      let reader = new FileReader();
      reader.onload = (event: any) => {
        this.imageData = event.target.result;
      }
      reader.onloadend = function () {
        self._productService.featureImage = reader.result
      }
      reader.readAsDataURL(this.fileToUpload);
    } catch { }
  }

  handleLabelFileInput(event: any) {
    try {
      let file = event.target.files;
      this.fileToUpload = file.item(0);
      const self = this
      //Show image preview
      let reader = new FileReader();
      reader.onload = (event: any) => {
        this.imageData = event.target.result;
      }
      reader.onloadend = function () {
        self._productService.labelPrintingImage = reader.result
      }
      reader.readAsDataURL(this.fileToUpload);
    } catch { }
  }

  removeImage() {
    this._productService.featureImage = null
    this.imageData = this.dummyImageData;
  }

  removeLabelImage() {
    this._productService.labelPrintingImage = "";
    this.imageData = this.dummyImageData;
  }

}
